import { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import "../styles/DashboardLayout.css";
import AdminContainer from "../components/AdminContainer.jsx";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="dashboard-container">

      {/* Overlay — solo visible en móvil cuando el menú está abierto */}
      <div
        className={`sidebar-overlay ${sidebarOpen ? "open" : ""}`}
        onClick={closeSidebar}
      />

      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="logo">
          <img
            src="https://valsoft.es/wp-content/uploads/2022/06/logo_azul_fondo_blanco_PUNTOS-tr.png"
            width="180"
            alt="Logo Valsoft"
          />
        </div>

        <nav className="nav">
          <NavLink to="/" className="nav-link" onClick={closeSidebar}>Inicio</NavLink>
          <AdminContainer rols={['admin']}>
            <NavLink to="/users" className="nav-link" onClick={closeSidebar}>Usuarios</NavLink>
          </AdminContainer>
          <AdminContainer rols={['admin']}>
            <NavLink to="/team" className="nav-link" onClick={closeSidebar}>Grupos</NavLink>
          </AdminContainer>
          <NavLink to="/notifications" className="nav-link" onClick={closeSidebar}>Notificaciones</NavLink>
          <NavLink to="/ajustes" className="nav-link" onClick={closeSidebar}>Ajustes</NavLink>
        </nav>
      </aside>

      <div className="main">
        <header className="navbar">
          {/* Botón hamburguesa — solo visible en móvil */}
          <button
            className={`hamburger ${sidebarOpen ? "open" : ""}`}
            onClick={() => setSidebarOpen(prev => !prev)}
            aria-label="Abrir menú"
          >
            <span />
            <span />
            <span />
          </button>

          <h3>Panel Administrativo</h3>
        </header>

        <main className="content">
          <Outlet />
        </main>
      </div>

    </div>
  );
}
